import SearchPageView from './SearchPageView'

export default SearchPageView